module.exports = {"button.close":"Close"}